import { render } from "./transport-list-custom.vue?vue&type=template&id=44ec24f0"
import script from "./transport-list-custom.vue?vue&type=script&lang=js"
export * from "./transport-list-custom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__